module.exports = __webpack_public_path__ + "assets/svg/pause_icon.svg";